export default class Invoice {
  constructor(data = {}) {
    this.invoiceNumber = data.invoiceNumber;
    this.paymentCompany = data.paymentCompany;
    this.payerCompany = data.payerCompany;
    this.total = data.total;
    this.amountDue = data.amountDue;
    this.scheduledAmount = data.scheduledAmount;
    this.scheduledPayments = data.scheduledPayments;
    this.invoiceDate = data.invoiceDate;
    this.dueDate = data.dueDate;
    this.timezone = data.timezone;
    this.hasOutstandingInvoices = !!data.hasOutstandingInvoices;
    this.isInvoiceLocked = data.isInvoiceLocked;
    this.isSynced = typeof data.isSynced == "boolean" ? data.isSynced : true;
  }

  get isPrepayment() {
    return !this.isSynced;
  }

  get hasScheduledPayments() {
    return this.scheduledAmount;
  }
}
